import { useCallback, useEffect } from 'react'

export function useEventListener(
  eventName: string,
  handler: (event: Event) => void,
  deps: Array<any>,
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedHandler = useCallback(handler, deps)

  useEffect(() => {
    window.addEventListener(eventName, memoizedHandler)
    return () => window.removeEventListener(eventName, memoizedHandler)
  }, [eventName, memoizedHandler])
}
